import { AuctionLotSearchFilterItemChoicesModel, AuctionLotSearchFilterItemRangeModel, AuctionLotSearchFilterItemTextModel } from "../auction/models";

export class AuctionLotSearchFilters {
    keyword: AuctionLotSearchFilterItemTextModel;
    category: AuctionLotSearchFilterItemChoicesModel;
    lotNumber: AuctionLotSearchFilterItemTextModel;
    price: AuctionLotSearchFilterItemRangeModel;
    country: AuctionLotSearchFilterItemChoicesModel;
    region: AuctionLotSearchFilterItemChoicesModel;
    vintage: AuctionLotSearchFilterItemChoicesModel;
    winery: AuctionLotSearchFilterItemChoicesModel;
    variety: AuctionLotSearchFilterItemChoicesModel;
    unitOfMeasure: AuctionLotSearchFilterItemChoicesModel;
    excludeAttribute: AuctionLotSearchFilterItemChoicesModel;
    vendorView: boolean;

    constructor() {
        this.keyword = new AuctionLotSearchFilterItemTextModel();
        this.category = new AuctionLotSearchFilterItemChoicesModel();
        this.lotNumber = new AuctionLotSearchFilterItemTextModel();
        this.price = new AuctionLotSearchFilterItemRangeModel();
        this.country = new AuctionLotSearchFilterItemChoicesModel();
        this.region = new AuctionLotSearchFilterItemChoicesModel();
        this.vintage = new AuctionLotSearchFilterItemChoicesModel();
        this.winery = new AuctionLotSearchFilterItemChoicesModel();
        this.variety = new AuctionLotSearchFilterItemChoicesModel();
        this.unitOfMeasure = new AuctionLotSearchFilterItemChoicesModel();
        this.excludeAttribute = new AuctionLotSearchFilterItemChoicesModel();
        this.vendorView = false;
    }
}